import { type App, defineAsyncComponent } from 'vue'

const components = {
  MarkdownBody: defineAsyncComponent(() => import('./MarkdownBody.vue')),
  MarkdownRuns: defineAsyncComponent(() => import('./MarkdownRuns.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
